<template>
  <b-row class="mt-2"
         v-if="invitations.length !== 0">
    <b-col>
      <b-card class="rounded-0">
        <h4>
          {{ $t('message.adminUserInvitation.title') }}
        </h4>

        <b-table striped
                 responsive
                 :fields="fields"
                 :items="invitations"
                 tbody-class="text-muted">
          <template slot="createdAt" slot-scope="row">
            {{ $moment(row.item.createdAt, 'YYYY-MM-DD').format('DD.MM.YYYY') }}
          </template>
          <template slot="status" slot-scope="row">
            {{ $t('enums.invitationStatus.' + row.item.status) }}
          </template>
        </b-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'AdminUserInvitation',
    created () {
      if (!this.invitations.length) {
        const id = parseInt(this.$route.params.id)
        this.$store.dispatch('fetchAdminUserInvitationList', id).then(() => {
          this.invitations = this.$store.getters.adminUserInvitationList
        }).catch(() => {
        })
      }
    },
    data () {
      return {
        fields: [{
          key: 'contactPersonFirstname',
          label: this.$t('message.adminUserInvitation.table.contactPersonFirstname')
        }, {
          key: 'contactPersonLastname',
          label: this.$t('message.adminUserInvitation.table.contactPersonLastname')
        }, {
          key: 'contactPersonEmail',
          label: this.$t('message.adminUserInvitation.table.contactPersonEmail')
        }, {
          key: 'createdAt',
          label: this.$t('message.adminUserInvitation.table.createdAt')
        }, {
          key: 'status',
          label: this.$t('message.adminUserInvitation.table.status')
        }],
        invitations: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminUserInvitation.vue